module.exports = __webpack_public_path__ + "img/Vector 15.53bb17b0.jpg";